module.exports = __webpack_public_path__ + "img/summit-screens.68fef53a.png";